<div class="grid grid-cols-12 gap-8">
    <app-statswidget class="contents" />
    <div class="col-span-12 xl:col-span-6">
        <app-tableloans />
        <!-- <app-best-selling-widget /> -->
    </div>
    <div class="col-span-12 xl:col-span-6">
        <app-graphloans />
        <!-- <app-notifications-widget /> -->
    </div>
</div>